webpackJsonp([31,41],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = checkIntersection;
function checkIntersection($el, callback) {
  var $scrollListener = document.querySelector('.scroll-listener');
  var observerActive = false;

  function onScrollUpdate() {
    if (observerActive === false) {
      observerActive = true;

      setTimeout(function () {
        if ($el.getBoundingClientRect().top < window.innerHeight && $el.getBoundingClientRect().bottom >= 0 && $el.clientWidth > 0 && $el.clientHeight > 0) {
          callback();
          $scrollListener.Component['scroll-listener'].removeObserver(onScrollUpdate);
        }

        observerActive = false;
      }, 200);
    }
  }

  onScrollUpdate();

  $scrollListener.Component['scroll-listener'].addObserver(onScrollUpdate);
}

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__ = __webpack_require__(171);



/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initState: {
      isInView: false,
      mediaQuery: false
    },
    initFunction: function initFunction($el, params) {
      var $imageLandscape = $el.querySelector('.' + nameSpace + '__svg--is-landscape .' + nameSpace + '__image');
      var $imagePortrait = $el.querySelector('.' + nameSpace + '__svg--is-portrait .' + nameSpace + '__image');

      //
      // Methods
      //

      function setMediaQuery() {
        if (window.innerWidth > window.innerHeight && params.getState().mediaQuery !== 'landscape') {
          params.setState({ mediaQuery: 'landscape' });
        } else if (window.innerWidth <= window.innerHeight && params.getState().mediaQuery !== 'portrait') {
          params.setState({ mediaQuery: 'portrait' });
        }
      }

      //
      // Life Cycle
      //

      params.onStateUpdate(function (newState, prevState) {
        if (newState.isInView) {
          if (newState.mediaQuery === 'landscape' && !$imageLandscape.getAttributeNS('http://www.w3.org/1999/xlink', 'href')) {
            $imageLandscape.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', $imageLandscape.dataset.href);
          } else if (newState.mediaQuery === 'portrait' && !$imagePortrait.getAttributeNS('http://www.w3.org/1999/xlink', 'href')) {
            $imagePortrait.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', $imagePortrait.dataset.href);
          }
        }
      });

      //
      // Procedures
      //

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__["default"])($el, function () {
        params.setState({ isInView: true });
      });

      setMediaQuery();
    }
  });
});

/***/ })

});


// WEBPACK FOOTER //
// js/chunk-editorial-full-picture.bundle.js